import styled from "styled-components";

import { STATUS_COLORS, STATUS_LABEL, STATUS_LABEL_SHORT } from "pages/Sikring/sikringUtils";
import { Sikringsordrestatus } from "pages/Sikring/types";

/** `short` gir kortere etikett, for tabellen. */
export function StatusBadge({ status, short = false }: Readonly<{ status: Sikringsordrestatus; short?: boolean }>) {
	const { background, color } = STATUS_COLORS[status];
	return (
		<Badge $background={background} $color={color}>
			{(short ? STATUS_LABEL_SHORT : STATUS_LABEL)[status]}
		</Badge>
	);
}

interface BadgeProps {
	$background: string;
	$color: string;
}

const Badge = styled.span<BadgeProps>`
	display: inline-block;
	padding: 3px 10px;
	border-radius: 9px;
	font-weight: 700;
	font-size: 0.75rem;
	white-space: nowrap;
	background: ${(props) => props.$background};
	color: ${(props) => props.$color};
`;
